"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _opentokReact = require("opentok-react");
var _ = require("../..");
var _utils = require("../../../utils");
var _Publisher = _interopRequireDefault(require("./Publisher"));
var _constants = require("../constants");
var _PublisherMessage = _interopRequireDefault(require("./PublisherMessage"));
var _Subscriber = _interopRequireDefault(require("./Subscriber"));
var _Video = require("./Video");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useMuteMessages = function useMuteMessages(publisherAudioEnabled, subscriber, targetName) {
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    isSubscriberMuted = _useState2[0],
    setIsSubscriberMuted = _useState2[1];
  (0, _react.useEffect)(function () {
    var checkIfMuted = function checkIfMuted() {
      var _subscriber$stream;
      var isMuted = (subscriber === null || subscriber === void 0 ? void 0 : (_subscriber$stream = subscriber.stream) === null || _subscriber$stream === void 0 ? void 0 : _subscriber$stream.hasAudio) === false;
      if (isMuted !== isSubscriberMuted) {
        setIsSubscriberMuted(isMuted);
      }
    };
    var interval = setInterval(function () {
      checkIfMuted();
    }, 1000);
    return function () {
      clearInterval(interval);
    };
  }, [isSubscriberMuted, subscriber]);
  var muteMessages = (0, _react.useMemo)(function () {
    return (0, _lodash.compact)([!publisherAudioEnabled && 'You are on mute', isSubscriberMuted && "".concat(targetName, " is on mute")]);
  }, [publisherAudioEnabled, isSubscriberMuted, targetName]);
  return muteMessages;
};
var useDisconnectionTrigger = function useDisconnectionTrigger(performDisconnect) {
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    disconnectionEvent = _useState4[0],
    setDisconnectionEvent = _useState4[1];
  (0, _react.useEffect)(function () {
    if (disconnectionEvent) {
      performDisconnect(disconnectionEvent);
    }
  }, [!!disconnectionEvent]);
  return setDisconnectionEvent;
};
var OTVideo = function OTVideo(props) {
  var _user$profile;
  var apiKey = props.apiKey,
    audioEnabled = props.audioEnabled,
    connectionStatus = props.connectionStatus,
    devices = props.devices,
    isSubscriberVideoEnabled = props.isSubscriberVideoEnabled,
    onConnectionStatusChange = props.onConnectionStatusChange,
    onConnect = props.onConnect,
    onError = props.onError,
    onDisconnect = props.onDisconnect,
    onSubscribe = props.onSubscribe,
    roomId = props.roomId,
    setIsSubscriberVideoEnabled = props.setIsSubscriberVideoEnabled,
    token = props.token,
    videoEnabled = props.videoEnabled,
    user = props.user,
    onFinish = props.onFinish,
    toggleScreenSharingEnabled = props.toggleScreenSharingEnabled,
    isScreenShareOn = props.isScreenShareOn,
    toggleIsScreenShareOn = props.toggleIsScreenShareOn,
    isSubscriberScreenSharingEnabled = props.isSubscriberScreenSharingEnabled,
    setIsSubscriberScreenSharingEnabled = props.setIsSubscriberScreenSharingEnabled;
  var _useVideoChat = (0, _.useVideoChat)(),
    target = _useVideoChat.target;

  // this state is used to listen to both disconnect and destroy events, but execute disconnect only once
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    disconnectionState = _useState6[0],
    setDisconnectionState = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    message = _useState8[0],
    setMessage = _useState8[1];
  var _useState9 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState9, 2),
    reconnectionAttemptsNumber = _useState10[0],
    setReconnectionAttemptsNumber = _useState10[1];
  var addReconnectionAttempt = (0, _react.useCallback)(function () {
    setReconnectionAttemptsNumber(function (n) {
      return n + 1;
    });
  }, [setReconnectionAttemptsNumber]);
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    session = _useState12[0],
    setSession = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    subscriber = _useState14[0],
    setSubscriber = _useState14[1];
  var connectionId = (0, _react.useMemo)(function () {
    return session === null || session === void 0 ? void 0 : session.connection.id;
  }, [session]);
  var userAvatarImage = (0, _utils.isClinician)(user) ? user === null || user === void 0 ? void 0 : (_user$profile = user.profile) === null || _user$profile === void 0 ? void 0 : _user$profile.image : '';
  var userAvatarName = (0, _utils.isClinician)(user) ? (0, _utils.personName)(user === null || user === void 0 ? void 0 : user.profile) : user === null || user === void 0 ? void 0 : user.nickName;
  var targetAvatarImage = (0, _utils.isClinician)(target) ? target.image : '';
  var targetName = (0, _utils.isClinician)(target) ? (0, _utils.personName)(target) : target.nickName;
  var updateMessage = (0, _react.useCallback)(function (message) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!disconnectionState) {
      setMessage(message);
    }
    if (duration) {
      setTimeout(function () {
        setMessage(null);
      }, duration);
    }
  }, [disconnectionState]);
  var performDisconnect = function performDisconnect(e) {
    var isDisconnecting = [_constants.DISCONNECT_ACTION.DISCONNECTED, _constants.DISCONNECT_ACTION.DISCONNECTING].includes(disconnectionState);
    if (e.reason === 'networkDisconnected' && !isDisconnecting && reconnectionAttemptsNumber) {
      onError({
        name: 'OT_TIMEOUT'
      });
    }
    setDisconnectionState(_constants.DISCONNECT_ACTION.DISCONNECTING);
    if (_Video.VIDEO_LOGGING_VERBOSE) {
      console.error('performDisconnect', e);
    }
  };
  var triggerDisconnection = useDisconnectionTrigger(performDisconnect);
  (0, _react.useEffect)(function () {
    var disconnect = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setDisconnectionState(_constants.DISCONNECT_ACTION.DISCONNECTED);
                if (!onDisconnect) {
                  _context.next = 4;
                  break;
                }
                _context.next = 4;
                return onDisconnect();
              case 4:
                onConnectionStatusChange(_utils.SessionEvents.Disconnected);
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function disconnect() {
        return _ref.apply(this, arguments);
      };
    }();
    if (disconnectionState === _constants.DISCONNECT_ACTION.DISCONNECTING) {
      disconnect();
    }
  }, [disconnectionState, onConnectionStatusChange, onDisconnect]);
  var muteMessages = useMuteMessages(audioEnabled, subscriber, targetName);
  var sessionEventHandlers = {
    streamCreated: function streamCreated(e) {
      if (e.stream.videoType === 'screen') {
        setIsSubscriberScreenSharingEnabled(true);
      }
    },
    streamDestroyed: function streamDestroyed(e) {
      if (e.stream.videoType === 'screen') {
        setIsSubscriberScreenSharingEnabled(false);
      }
    },
    connectionDestroyed: function connectionDestroyed(e) {
      if (_Video.VIDEO_LOGGING_VERBOSE) {
        console.error('connectionDestroyed', e);
      }
      updateMessage(_constants.MESSAGES.SUBSCRIBER_DISCONNECTED(targetName));
    },
    connectionCreated: function connectionCreated() {
      return updateMessage(_constants.MESSAGES.SUBSCRIBER_CONNECTED(targetName), 3000);
    },
    sessionConnected: function sessionConnected(e) {
      return setSession(e.target);
    },
    sessionReconnected: function sessionReconnected(e) {
      if (_Video.VIDEO_LOGGING_VERBOSE) {
        console.error('sessionReconnected', e);
      }
      onConnectionStatusChange(_utils.SessionEvents.Reconnected);
      updateMessage(_constants.MESSAGES.PUBLISHER_CONNECTED(), 3000);
      addReconnectionAttempt();
    },
    sessionReconnecting: function sessionReconnecting(e) {
      if (_Video.VIDEO_LOGGING_VERBOSE) {
        console.error('sessionReconnecting', e);
      }
      addReconnectionAttempt();
      onConnectionStatusChange(_utils.SessionEvents.Reconnecting);
      updateMessage(_constants.MESSAGES.PUBLISHER_DISCONNECTED());
    },
    sessionDisconnected: triggerDisconnection
  };
  var publisherProps = {
    addReconnectionAttempt: addReconnectionAttempt,
    audioEnabled: audioEnabled,
    toggleScreenSharingEnabled: toggleScreenSharingEnabled,
    isScreenShareOn: isScreenShareOn,
    toggleIsScreenShareOn: toggleIsScreenShareOn,
    devices: devices,
    message: message,
    onConnect: onConnect,
    onError: onError,
    updateMessage: updateMessage,
    userAvatarImage: userAvatarImage,
    userAvatarName: userAvatarName,
    videoEnabled: videoEnabled
  };
  var subscriberProps = {
    connectionId: connectionId,
    connectionStatus: connectionStatus,
    isSubscriberVideoEnabled: isSubscriberVideoEnabled,
    isSubscriberScreenSharingEnabled: isSubscriberScreenSharingEnabled,
    message: message,
    onConnectionStatusChange: onConnectionStatusChange,
    onError: onError,
    onFinish: onFinish,
    onSubscribe: onSubscribe,
    setIsSubscriberVideoEnabled: setIsSubscriberVideoEnabled,
    setSubscriber: setSubscriber,
    subscriber: subscriber,
    targetAvatarImage: targetAvatarImage,
    targetName: targetName,
    updateMessage: updateMessage
  };
  return /*#__PURE__*/_react.default.createElement(_opentokReact.OTSession, {
    apiKey: apiKey,
    sessionId: roomId,
    token: token,
    onError: onError,
    eventHandlers: sessionEventHandlers,
    className: "session"
  }, /*#__PURE__*/_react.default.createElement(_Subscriber.default, subscriberProps), /*#__PURE__*/_react.default.createElement(_Publisher.default, publisherProps), !!muteMessages.length && /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-mute-messages absolute w-full bottom-[80px] px-[10px] text-center text-white tw-body-regular"
  }, muteMessages.map(function (str) {
    return /*#__PURE__*/_react.default.createElement("p", {
      key: str
    }, str);
  })), /*#__PURE__*/_react.default.createElement(_PublisherMessage.default, {
    message: message,
    targetName: targetName
  }));
};
OTVideo.propTypes = {
  apiKey: _propTypes.default.string,
  audioEnabled: _propTypes.default.bool,
  onConnectionStatusChange: _propTypes.default.func,
  onConnect: _propTypes.default.func,
  onError: _propTypes.default.func,
  onFinish: _propTypes.default.func,
  onSubscribe: _propTypes.default.func,
  roomId: _propTypes.default.string,
  token: _propTypes.default.string,
  videoEnabled: _propTypes.default.bool
};
var _default = (0, _opentokReact.preloadScript)(OTVideo);
exports.default = _default;